var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowban(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 101,
    viewBox: "0 0 159 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.8269C0 4.39966 4.39965 0 9.8269 0H19.6538V19.6538H9.8269C4.39966 19.6538 0 15.2541 0 9.8269V9.8269Z",
    fill: "#3E2C68"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 6.29883H19.7516V17.3401H16.4655V11.9085L7.55796 20.816L5.23438 18.4924L14.142 9.58487H8.666V6.29883Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 6.29883H19.7516V17.3401H16.4655V11.9085L7.55796 20.816L5.23438 18.4924L14.142 9.58487H8.666V6.29883Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.1667C0 30.7395 4.39965 26.3398 9.8269 26.3398H19.6538V45.9936H9.8269C4.39966 45.9936 0 41.594 0 36.1667V36.1667Z",
    fill: "#3E2C68"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 32.6387H19.7516V43.68H16.4655V38.2483L7.55796 47.1559L5.23438 44.8323L14.142 35.9247H8.666V32.6387Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 32.6387H19.7516V43.68H16.4655V38.2483L7.55796 47.1559L5.23438 44.8323L14.142 35.9247H8.666V32.6387Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 0,
    width: 21,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6016 9.8269C83.6016 4.39966 88.0012 0 93.4285 0H103.255V19.6538H93.4285C88.0012 19.6538 83.6016 15.2541 83.6016 9.8269V9.8269Z",
    fill: "#3E2C68"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2676 6.29883H103.353V17.3401H100.067V11.9085L91.1595 20.816L88.8359 18.4924L97.7435 9.58487H92.2676V6.29883Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2676 6.29883H103.353V17.3401H100.067V11.9085L91.1595 20.816L88.8359 18.4924L97.7435 9.58487H92.2676V6.29883Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 26,
    width: 21,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6016 36.1667C83.6016 30.7395 88.0012 26.3398 93.4285 26.3398H103.255V45.9936H93.4285C88.0012 45.9936 83.6016 41.594 83.6016 36.1667V36.1667Z",
    fill: "#3E2C68"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2676 32.6387H103.353V43.68H100.067V38.2483L91.1595 47.1559L88.8359 44.8323L97.7435 35.9247H92.2676V32.6387Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2676 32.6387H103.353V43.68H100.067V38.2483L91.1595 47.1559L88.8359 44.8323L97.7435 35.9247H92.2676V32.6387Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 0,
    width: 21,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8672 9.8269C27.8672 4.39966 32.2668 0 37.6941 0H47.521V19.6538H37.6941C32.2668 19.6538 27.8672 15.2541 27.8672 9.8269V9.8269Z",
    fill: "#3E2C68"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5332 6.29883H47.6188V17.3401H44.3327V11.9085L35.4251 20.816L33.1016 18.4924L42.0091 9.58487H36.5332V6.29883Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5332 6.29883H47.6188V17.3401H44.3327V11.9085L35.4251 20.816L33.1016 18.4924L42.0091 9.58487H36.5332V6.29883Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 26,
    width: 21,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8672 36.1667C27.8672 30.7395 32.2668 26.3398 37.6941 26.3398H47.521V45.9936H37.6941C32.2668 45.9936 27.8672 41.594 27.8672 36.1667V36.1667Z",
    fill: "#3E2C68"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5332 32.6387H47.6188V43.68H44.3327V38.2483L35.4251 47.1559L33.1016 44.8323L42.0091 35.9247H36.5332V32.6387Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5332 32.6387H47.6188V43.68H44.3327V38.2483L35.4251 47.1559L33.1016 44.8323L42.0091 35.9247H36.5332V32.6387Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 0,
    width: 21,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.473 9.8269C111.473 4.39966 115.872 0 121.3 0H131.126V19.6538H121.3C115.872 19.6538 111.473 15.2541 111.473 9.8269V9.8269Z",
    fill: "#3E2C68"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.143 6.29883H131.228V17.3401H127.942V11.9085L119.035 20.816L116.711 18.4924L125.619 9.58487H120.143V6.29883Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.143 6.29883H131.228V17.3401H127.942V11.9085L119.035 20.816L116.711 18.4924L125.619 9.58487H120.143V6.29883Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 26,
    width: 21,
    height: 20
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.473 36.1667C111.473 30.7395 115.872 26.3398 121.3 26.3398H131.126V45.9936H121.3C115.872 45.9936 111.473 41.594 111.473 36.1667V36.1667Z",
    fill: "#3E2C68"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.143 32.6387H131.228V43.68H127.942V38.2483L119.035 47.1559L116.711 44.8323L125.619 35.9247H120.143V32.6387Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.143 32.6387H131.228V43.68H127.942V38.2483L119.035 47.1559L116.711 44.8323L125.619 35.9247H120.143V32.6387Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 0,
    width: 21,
    height: 20
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7344 9.8269C55.7344 4.39966 60.134 0 65.5613 0H75.3882V19.6538H65.5613C60.134 19.6538 55.7344 15.2541 55.7344 9.8269V9.8269Z",
    fill: "#3E2C68"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4004 6.29883H75.486V17.3401H72.1999V11.9085L63.2923 20.816L60.9688 18.4924L69.8763 9.58487H64.4004V6.29883Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4004 6.29883H75.486V17.3401H72.1999V11.9085L63.2923 20.816L60.9688 18.4924L69.8763 9.58487H64.4004V6.29883Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 26,
    width: 21,
    height: 20
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7344 36.1667C55.7344 30.7395 60.134 26.3398 65.5613 26.3398H75.3882V45.9936H65.5613C60.134 45.9936 55.7344 41.594 55.7344 36.1667V36.1667Z",
    fill: "#3E2C68"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4004 32.6387H75.486V43.68H72.1999V38.2483L63.2923 47.1559L60.9688 44.8323L69.8763 35.9247H64.4004V32.6387Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4004 32.6387H75.486V43.68H72.1999V38.2483L63.2923 47.1559L60.9688 44.8323L69.8763 35.9247H64.4004V32.6387Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 0,
    width: 20,
    height: 20
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.34 9.8269C139.34 4.39966 143.739 0 149.167 0H158.994V19.6538H149.167C143.74 19.6538 139.34 15.2541 139.34 9.8269V9.8269Z",
    fill: "#3E2C68"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.01 6.29883H159.095V17.3401H155.809V11.9085L146.902 20.816L144.578 18.4924L153.486 9.58487H148.01V6.29883Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.01 6.29883H159.095V17.3401H155.809V11.9085L146.902 20.816L144.578 18.4924L153.486 9.58487H148.01V6.29883Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 26,
    width: 20,
    height: 20
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.34 36.1667C139.34 30.7395 143.739 26.3398 149.167 26.3398H158.994V45.9936H149.167C143.74 45.9936 139.34 41.594 139.34 36.1667V36.1667Z",
    fill: "#3E2C68"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.01 32.6387H159.095V43.68H155.809V38.2483L146.902 47.1559L144.578 44.8323L153.486 35.9247H148.01V32.6387Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.01 32.6387H159.095V43.68H155.809V38.2483L146.902 47.1559L144.578 44.8323L153.486 35.9247H148.01V32.6387Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 54,
    width: 20,
    height: 20
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 64.0808C0 58.6536 4.39965 54.2539 9.8269 54.2539H19.6538V73.9077H9.8269C4.39966 73.9077 0 69.5081 0 64.0808V64.0808Z",
    fill: "#3E2C68"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 60.5527H19.7516V71.594H16.4655V66.1624L7.55796 75.0699L5.23438 72.7463L14.142 63.8388H8.666V60.5527Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 60.5527H19.7516V71.594H16.4655V66.1624L7.55796 75.0699L5.23438 72.7463L14.142 63.8388H8.666V60.5527Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 80,
    width: 20,
    height: 21
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.4207C0 84.9934 4.39965 80.5938 9.8269 80.5938H19.6538V100.248H9.8269C4.39966 100.248 0 95.8479 0 90.4207V90.4207Z",
    fill: "#3E2C68"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 86.8926H19.7516V97.9339H16.4655V92.5022L7.55796 101.41L5.23438 99.0862L14.142 90.1786H8.666V86.8926Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.666 86.8926H19.7516V97.9339H16.4655V92.5022L7.55796 101.41L5.23438 99.0862L14.142 90.1786H8.666V86.8926Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 54,
    width: 21,
    height: 20
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6016 64.0808C83.6016 58.6536 88.0012 54.2539 93.4285 54.2539H103.255V73.9077H93.4285C88.0012 73.9077 83.6016 69.5081 83.6016 64.0808V64.0808Z",
    fill: "#3E2C68"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2676 60.5527H103.353V71.594H100.067V66.1624L91.1595 75.0699L88.8359 72.7463L97.7435 63.8388H92.2676V60.5527Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2676 60.5527H103.353V71.594H100.067V66.1624L91.1595 75.0699L88.8359 72.7463L97.7435 63.8388H92.2676V60.5527Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 80,
    width: 21,
    height: 21
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6016 90.4207C83.6016 84.9934 88.0012 80.5938 93.4285 80.5938H103.255V100.248H93.4285C88.0012 100.248 83.6016 95.8479 83.6016 90.4207V90.4207Z",
    fill: "#3E2C68"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2676 86.8926H103.353V97.9339H100.067V92.5022L91.1595 101.41L88.8359 99.0862L97.7435 90.1786H92.2676V86.8926Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2676 86.8926H103.353V97.9339H100.067V92.5022L91.1595 101.41L88.8359 99.0862L97.7435 90.1786H92.2676V86.8926Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 54,
    width: 21,
    height: 20
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8672 64.0808C27.8672 58.6536 32.2668 54.2539 37.6941 54.2539H47.521V73.9077H37.6941C32.2668 73.9077 27.8672 69.5081 27.8672 64.0808V64.0808Z",
    fill: "#3E2C68"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5332 60.5527H47.6188V71.594H44.3327V66.1624L35.4251 75.0699L33.1016 72.7463L42.0091 63.8388H36.5332V60.5527Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5332 60.5527H47.6188V71.594H44.3327V66.1624L35.4251 75.0699L33.1016 72.7463L42.0091 63.8388H36.5332V60.5527Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 80,
    width: 21,
    height: 21
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8672 90.4207C27.8672 84.9934 32.2668 80.5938 37.6941 80.5938H47.521V100.248H37.6941C32.2668 100.248 27.8672 95.8479 27.8672 90.4207V90.4207Z",
    fill: "#3E2C68"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5332 86.8926H47.6188V97.9339H44.3327V92.5022L35.4251 101.41L33.1016 99.0862L42.0091 90.1786H36.5332V86.8926Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5332 86.8926H47.6188V97.9339H44.3327V92.5022L35.4251 101.41L33.1016 99.0862L42.0091 90.1786H36.5332V86.8926Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 54,
    width: 21,
    height: 20
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.473 64.0808C111.473 58.6536 115.872 54.2539 121.3 54.2539H131.126V73.9077H121.3C115.872 73.9077 111.473 69.5081 111.473 64.0808V64.0808Z",
    fill: "#3E2C68"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.143 60.5527H131.228V71.594H127.942V66.1624L119.035 75.0699L116.711 72.7463L125.619 63.8388H120.143V60.5527Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.143 60.5527H131.228V71.594H127.942V66.1624L119.035 75.0699L116.711 72.7463L125.619 63.8388H120.143V60.5527Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 80,
    width: 21,
    height: 21
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.473 90.4207C111.473 84.9934 115.872 80.5938 121.3 80.5938H131.126V100.248H121.3C115.872 100.248 111.473 95.8479 111.473 90.4207V90.4207Z",
    fill: "#3E2C68"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.143 86.8926H131.228V97.9339H127.942V92.5022L119.035 101.41L116.711 99.0862L125.619 90.1786H120.143V86.8926Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.143 86.8926H131.228V97.9339H127.942V92.5022L119.035 101.41L116.711 99.0862L125.619 90.1786H120.143V86.8926Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 54,
    width: 21,
    height: 20
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7344 64.0808C55.7344 58.6536 60.134 54.2539 65.5613 54.2539H75.3882V73.9077H65.5613C60.134 73.9077 55.7344 69.5081 55.7344 64.0808V64.0808Z",
    fill: "#3E2C68"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4004 60.5527H75.486V71.594H72.1999V66.1624L63.2923 75.0699L60.9688 72.7463L69.8763 63.8388H64.4004V60.5527Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4004 60.5527H75.486V71.594H72.1999V66.1624L63.2923 75.0699L60.9688 72.7463L69.8763 63.8388H64.4004V60.5527Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 80,
    width: 21,
    height: 21
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7344 90.4207C55.7344 84.9934 60.134 80.5938 65.5613 80.5938H75.3882V100.248H65.5613C60.134 100.248 55.7344 95.8479 55.7344 90.4207V90.4207Z",
    fill: "#3E2C68"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4004 86.8926H75.486V97.9339H72.1999V92.5022L63.2923 101.41L60.9688 99.0862L69.8763 90.1786H64.4004V86.8926Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4004 86.8926H75.486V97.9339H72.1999V92.5022L63.2923 101.41L60.9688 99.0862L69.8763 90.1786H64.4004V86.8926Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 54,
    width: 20,
    height: 20
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.34 64.0808C139.34 58.6536 143.739 54.2539 149.167 54.2539H158.994V73.9077H149.167C143.74 73.9077 139.34 69.5081 139.34 64.0808V64.0808Z",
    fill: "#3E2C68"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.01 60.5527H159.095V71.594H155.809V66.1624L146.902 75.0699L144.578 72.7463L153.486 63.8388H148.01V60.5527Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.01 60.5527H159.095V71.594H155.809V66.1624L146.902 75.0699L144.578 72.7463L153.486 63.8388H148.01V60.5527Z",
    fill: "#DDEE36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_513_3013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 80,
    width: 20,
    height: 21
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.34 90.4207C139.34 84.9934 143.739 80.5938 149.167 80.5938H158.994V100.248H149.167C143.74 100.248 139.34 95.8479 139.34 90.4207V90.4207Z",
    fill: "#3E2C68"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_513_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.01 86.8926H159.095V97.9339H155.809V92.5022L146.902 101.41L144.578 99.0862L153.486 90.1786H148.01V86.8926Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.01 86.8926H159.095V97.9339H155.809V92.5022L146.902 101.41L144.578 99.0862L153.486 90.1786H148.01V86.8926Z",
    fill: "#DDEE36"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowban);
export default __webpack_public_path__ + "static/media/arrowban.9ba8855404d451b401b7e34bdd77cf86.svg";
export { ForwardRef as ReactComponent };